import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(content)/register/components/mainRegister.tsx");
